import { createContext, useContext } from 'react'

/**
 * The viewport offset at which the next sticky element should pin.
 *
 * Levels compose: each one pins at the offset it receives, then provides that offset plus its own
 * height to whatever is nested inside. So the page header publishes its height, the card header pins
 * under it, a property banner pins under the card header, and that property's column headers pin
 * under the banner — with no level needing to know the total above it.
 *
 * `null` means the dashboard hasn't opted in, and nothing pins.
 */
export const StickyOffsetContext = createContext<number | null>(null)

export const useStickyOffset = () => useContext(StickyOffsetContext)
